import { render, staticRenderFns } from "./MobileCustomDetail.vue?vue&type=template&id=030ec182&scoped=true&"
import script from "./MobileCustomDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCustomDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCustomDetail.vue?vue&type=style&index=0&id=030ec182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030ec182",
  null
  
)

export default component.exports